import { isEqual } from 'lodash'

export const validateLabelForFieldName = (value: string) => {
  //
  // empty value evaluates to true to allow empty field
  // to pass validation. Use 'required' validation
  // in addition to this one to validate for presence
  // of value.
  //
  if (isEqual(value, '')) {
    return true || ''
  }
  const regex = new RegExp(
    /^^(?=.*[a-zA-Z].*[a-zA-Z0-9])[a-zA-Z0-9(]([a-zA-Z0-9()._]+\s)*[a-zA-Z0-9()._]+$/
  )
  return regex.test(value) || labelForFieldNameHint
}

export const labelForFieldNameHint =
  'You can use upper and lower case letters, spaces and . (but not as first' +
  ' or last character), numbers, (), and underscore (but not as first character)'
